/* entry: collection */

import './collection.scss';
